import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpHeaders
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Globals } from "projects/shared/models/Globals";
@Injectable()
export class LangInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const clonedRequest = req.clone({
      headers: new HttpHeaders().set("culture", Globals.Culture)
                                .set('Cache-Control', 'no-cache')
                                .set('Pragma', 'no-cache')
                                .set('Strict-Transport-Security', 'max-age=60000; includeSubDomains')
    });
    return next.handle(clonedRequest);
  }
}
